module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Music-e429da52df62883b33641bc81802c1fa.svg";